

const SplashScreen = props => {
  return (
    <div></div>
  )
};

export default SplashScreen;